import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { asCurrency, asQuantityWithUnit } from '../../utils/formatters';

const MetricsChart = ({
  metrics,
  data,
  onMouseMove,
  onMouseLeave,
  showGridlines,
  ticks,
  showTooltip = true,
}) => {
  const formatTooltip = (value, name) => {
    const { format, displayName } = metrics.find((m) => m.accessor === name);
    return [format(value), displayName];
  };

  const yAxes = [...new Set(metrics.map(({ yAxisId }) => yAxisId))];

  return (
    <ResponsiveContainer width="99%" height="99%">
      <LineChart
        width={500}
        height={300}
        data={data}
        margin={{ top: 5, right: 0, bottom: 5, left: 40 }}
        onMouseMove={onMouseMove}
        onMouseLeave={onMouseLeave}
      >
        {showGridlines && <CartesianGrid horizontal={false} />}
        <XAxis
          dataKey="year"
          axisLine={false}
          tickLine={false}
          dy={10}
          ticks={ticks}
        />
        {yAxes.map((unit) => (
          <YAxis
            key={unit}
            yAxisId={unit}
            tickFormatter={
              unit === 'currency' ? asCurrency : asQuantityWithUnit(unit)
            }
            axisLine={false}
            tickLine={false}
            tick={{ width: 70 }}
          />
        ))}
        {metrics.map(({ accessor, color, yAxisId }) => (
          <Line
            type="monotone"
            dot={false}
            key={accessor}
            dataKey={accessor}
            stroke={color}
            yAxisId={yAxisId}
          />
        ))}
        <Tooltip
          formatter={formatTooltip}
          wrapperClassName={showTooltip ? '' : 'd-none'}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default MetricsChart;
